// Patient drafts stay in this browser tab, expire after eight hours, and never include passwords.
const PREFIX = 'nutrisync_patient_draft:';
const MAX_AGE = 8 * 60 * 60 * 1000;
export const emptyPatientForm = () => ({
    nome: '',
    email: '',
    cpf: '',
    rg: '',
    birthDate: '',
    gender: 'male' as 'male' | 'female',
    bloodType: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    height: '',
    weight: '',
    activityLevel: 'moderate' as 'sedentary' | 'light' | 'moderate' | 'active' | 'very_active',
    goals: [] as string[],
    category: 'ativo' as 'ativo' | 'avaliacao' | 'alerta',
    medicalConditions: '',
    allergies: '',
    medications: '',
    supplements: '',
    initialObservations: '',
    objetivo: '', // Mantido para compatibilidade
    gamification: {
      enabled: false,
      sealThreshold: 70,
      specialRewardThreshold: 90,
      specialRewardText: '',
      unlockExerciseThreshold: 100,
    },
  });
export type PatientFormData = ReturnType<typeof emptyPatientForm>;
export interface PatientDraft {
  data: PatientFormData;
  editingPatientId: string | null;
  manualPassword: boolean;
  savedAt: number;
}
export function readPatientDraft(uid?: string): PatientDraft | null {
  if (!uid) return null;
  try {
    const raw = window.sessionStorage.getItem(PREFIX + uid);
    if (!raw) return null;
    const draft = JSON.parse(raw);
    if (!Number.isFinite(draft.savedAt) || draft.savedAt > Date.now() || Date.now() - draft.savedAt > MAX_AGE || !draft.data || typeof draft.data !== 'object') {
      window.sessionStorage.removeItem(PREFIX + uid);
      return null;
    }
    const clean = emptyPatientForm();
    for (const key of Object.keys(clean) as Array<keyof PatientFormData>) {
      const value = draft.data[key];
      if (key === 'goals') {
        clean.goals = Array.isArray(value) ? value.filter((item: unknown) => typeof item === 'string') : [];
      } else if (key === 'gamification') {
        for (const field of Object.keys(clean.gamification) as Array<keyof PatientFormData['gamification']>) {
          if (typeof value?.[field] === typeof clean.gamification[field]) {
            (clean.gamification as any)[field] = value[field];
          }
        }
      } else if (typeof value === typeof clean[key]) {
        (clean as any)[key] = value;
      }
    }
    return { data: clean, savedAt: draft.savedAt, manualPassword: draft.manualPassword === true,
      editingPatientId: typeof draft.editingPatientId === 'string' ? draft.editingPatientId : null };
  } catch {
    return null;
  }
}
export function savePatientDraft(uid: string, data: PatientFormData, editingPatientId: string | null, manualPassword: boolean): boolean {
  try {
    // Whitelist form fields so credentials and unrelated properties cannot be persisted.
    const clean = Object.fromEntries(Object.keys(emptyPatientForm()).map(key => [key, data[key as keyof PatientFormData]]));
    window.sessionStorage.setItem(PREFIX + uid, JSON.stringify({ data: clean, editingPatientId, manualPassword, savedAt: Date.now() }));
    return true;
  } catch {
    return false;
  }
}
export function clearPatientDraft(uid?: string): void {
  if (!uid) return;
  try { window.sessionStorage.removeItem(PREFIX + uid); } catch { /* Storage may be disabled. */ }
}
export function clearAllPatientDrafts(): void {
  try {
    for (const key of Object.keys(window.sessionStorage)) {
      if (key.startsWith(PREFIX)) window.sessionStorage.removeItem(key);
    }
  } catch { /* Storage may be disabled. */ }
}
